import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { SidebarMode } from './ev-sidebarMode.enum';
@Injectable({
  providedIn: 'root',
})
export class EVSidebarService {
  private readonly sidebarModeSrc = new Subject<SidebarMode>();

  constructor() {}

  public setSidebarMode(option: SidebarMode) {
    this.sidebarModeSrc.next(option);
  }
  public clearSidebarMode() {
    this.sidebarModeSrc.next(null);
  }
  public sidepanelModeChange(): Observable<SidebarMode> {
    return this.sidebarModeSrc.asObservable();
  }
}
